export default __webpack_public_path__ + "static/media/LockBtnoutline.94c1185a.svg";